import { render } from "./MatrizesFormView.vue?vue&type=template&id=3fff42c3"
import script from "./MatrizesFormView.vue?vue&type=script&lang=js"
export * from "./MatrizesFormView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__